import dayjs from 'dayjs'

import { bigModalPropsTemplate, smallModalPropsTemplate } from '~/shared/molecules/Modal'

export const modalProps = {
  ...smallModalPropsTemplate,
  closeIconPosition: 'outside' as const,
  fillScreenOnMobile: true,
}

export const bigModalProps = {
  ...bigModalPropsTemplate,
  closeIconPosition: 'outside' as const,
  fillScreenOnMobile: true,
}

export const formatDateRange = (startDate: string, endDate: string): string => {
  const start = dayjs.parseZone(startDate).format('D MMMM')
  const end = dayjs.parseZone(endDate).format('D MMMM YYYY')

  return `${start} - ${end}`
}

export const storeSelectedMenus = (code: string, menus: number[]) => localStorage.setItem(code, JSON.stringify(menus))
export const getStoredMenus = (code: string) => {
  const storedMenus = localStorage.getItem(code)
  return storedMenus ? JSON.parse(storedMenus) : null
}
export const clearStoredMenus = (code: string) => {
  if (localStorage.getItem(code)) localStorage.removeItem(code)
}
